import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, Col, Row, Select, Spin} from "antd";

import './PrincipalRulesByCategoryCard.scss'
import LargeCardDashboard from "../CardDashboard/LargeCardDashobard/LargeCardDashobard";
import {getIndicatorsRulesPromise} from "../../../../promises";
import {camelizerHelper} from "../../../../../../helpers";
import TableModal from "../TableModal/TableModal";


const PrincipalRulesByCategoryCard = ({categories, globalActiveCategory, handleTabAlertas}) => {

    const {t} = useTranslation()

    const [allRules, setAllRules] = useState([])
    const [slicedRules, setSlicedRules] = useState(null)
    const [activeCategory, setActiveCategory] = useState(globalActiveCategory);
    const [activeAlertType, setActiveAlertType] = useState(null);
    const [activeAlertStatus, setActiveAlertStatus] = useState(null);
    const [isModalRulesVisible, setIsModalRulesVisible] = useState(null);

    let filter = {
        size: 10,
    };

    const alertType = ["PERSONA", "DEMOGRAFICA", "TRANSACCIONAL"]
    const alertStatus = ["OPEN", "CLOSED"]

    const rulesTableColumns = [
        {
            title: t("messages.aml.name"),
            dataIndex: "name",
            render: (text, record) => <a onClick={() => handleModalRuleClick(record)}>{camelizerHelper(text)}</a>,
        },
        {
            title: t("messages.aml.monitor.alertas"),
            dataIndex: "alertCount",
            render: (text, record) => <a onClick={() => handleModalRuleClick(record)}>{text}</a>,
        },
    ];

    useEffect(() => {
        handleSearch()
    }, [activeCategory, activeAlertType, activeAlertStatus]);

    const handleSearch = () => {

        filter.category = activeCategory
        filter.alertType = activeAlertType
        filter.status = activeAlertStatus

        getIndicatorsRulesPromise(filter).then((response) => {
            let data = response.data

            let sortData = [].concat(data)
                .sort((a, b) => b.alertCount > a.alertCount ? 1 : -1)

            setAllRules([...sortData])
            setSlicedRules([...sortData.slice(0, 4)])

        })
    }

    const handleSetActiveCategory = (category) => {
        setSlicedRules(null)
        setActiveCategory(category);
    };

    const handleSetActiveAlertType = (alertType) => {
        setSlicedRules(null)
        setActiveAlertType(alertType);
    };

    const handleSetActiveAlertStatus = (alertStatus) => {
        setSlicedRules(null)
        setActiveAlertStatus(alertStatus);
    };

    function getWidth(value) {

        if (slicedRules !== undefined) {
            let max = Object.values(slicedRules).map(x => x.alertCount)

            let percent = Math.max(...max)
            return (value * 100) / percent
        }
    }

    function getLegend() {
        return (
            <Row>
                <Col span={17} style={{paddingBottom: '20px'}}>
                    {t('messages.aml.monitor.principal.rules.by.cat.legend')}
                </Col>
            </Row>
        )
    }

    const handleModalTotalRulesCancel = () => {
        setIsModalRulesVisible(false)
    }

    const handleModalTotalRules = () => {
        setIsModalRulesVisible(true)
    }

    const getFilters = (ruleId) => {
        let filters = {ruleId: String(ruleId)}
        if(activeCategory) filters.categories = [activeCategory]
        if(activeAlertType) filters.types = [activeAlertType]
        if(activeAlertStatus === 'OPEN') filters.states = ['OPEN', 'READY']
        if(activeAlertStatus === 'CLOSED') filters.states = ['CLOSED']

        return filters
    }

    const handleModalRuleClick = (record) => {
        setIsModalRulesVisible(false)
        handleTabAlertas(getFilters(record.ruleId))
    }

    const getRulesResume = (totalRules) => {

        return (
            <>
                {
                    totalRules !== null ?
                        totalRules.length !== 0 ?
                            totalRules.map((rul, index) =>
                                <Row className={"row-principal-content"} key={index}>
                                    <Col span={8}>
                                        <div className={"Register-name"}>
                                            <a onClick={() => handleTabAlertas(getFilters(rul.ruleId))}>
                                                <span className={"rul-name"}>{camelizerHelper(rul.name)} </span>
                                            </a>
                                        </div>
                                    </Col>

                                    <Col span={12} offset={1}>
                                        <div className={"total-level-risk"}>
                                            <div className="level-risk-indicator"
                                                 style={{width: getWidth(rul.alertCount) + '%'}}>
                                                <div className={"text-risk-indicator"}>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col span={2} offset={1}>
                                        <div className={"level-risk-value"}>
                                            <a onClick={() => handleTabAlertas(getFilters(rul.ruleId))}>
                                                <span className="rul-name">{rul.alertCount}</span>
                                            </a>
                                        </div>
                                    </Col>

                                </Row>
                            )
                            : (
                                <div className={"label-no-info"}>
                                    <Row>
                                        <Col offset={7}>
                                            {t('messages.aml.monitor.no.rules')}
                                        </Col>
                                    </Row>
                                </div>)
                        :

                        <Row gutter={[0, 30]}>
                            <Col span={1} offset={11}>
                                <div className="spinner-principal-rul">
                                    <Spin spinning={true} size="large"/>
                                </div>
                            </Col>
                        </Row>
                }

                <br/>
                <br/>

                <Row>
                    <Col span={6}>
                        <Select
                            style={{width: "100%"}}
                            value={activeAlertType}
                            placeholder={t('messages.aml.monitor.type.alert')}
                            onChange={value => handleSetActiveAlertType(value)}
                        >
                            <Select.Option value={null}>{t('messages.aml.monitor.type.alert')}</Select.Option>
                            {alertType.map((type, index) => (
                                <Select.Option key={index} value={type}>
                                    {t('messages.aml.monitor.alertas.' + type)}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>


                    <Col span={6} offset={1}>
                        <Select
                            style={{width: "100%"}}
                            value={activeAlertStatus}
                            placeholder={t('messages.aml.monitor.all.alerts')}
                            onChange={value => handleSetActiveAlertStatus(value)}
                        >
                            <Select.Option value={null}>{t('messages.aml.monitor.all.alerts')}</Select.Option>
                            {alertStatus.map((status, index) => (
                                <Select.Option key={index} value={status}>
                                    {t('messages.aml.monitor.status.' + status)}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col span={6} offset={5}>
                        <Button className="show-all-alerts-by-category"
                                onClick={totalRules !== null && totalRules.length !== 0 ? handleModalTotalRules : null}>
                            <span className={"text"}> {t('messages.aml.monitor.principal.rules.complete.list')}</span>
                        </Button>
                    </Col>
                </Row>
            </>
        )
    }

    return (
        <>
            <div className='principal-rules-category'>
                <LargeCardDashboard
                    key={activeCategory}
                    title={t("messages.aml.monitor.rules.top." + (activeCategory ? activeCategory : 'null'))}
                    legend={getLegend()}
                    handleSetActiveCategory={handleSetActiveCategory}
                    activeCategory={activeCategory}
                    categories={categories}
                    content={getRulesResume(slicedRules)}
                />
            </div>

            {
                isModalRulesVisible &&
                <div id="modal-user">
                    <TableModal
                        onCancel={handleModalTotalRulesCancel}
                        dataSource={allRules}
                        columns={rulesTableColumns}
                        title={t("messages.aml.monitor.table.rules")}
                    />
                </div>
            }
        </>
    )

}

export default PrincipalRulesByCategoryCard;